module.exports = __webpack_public_path__ + "static/images/code_1449727c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.jpeg
// module id = 223
// module chunks = 1